import { apiClient } from '@/lib/api/client';
import type { InternalAxiosRequestConfig } from 'axios';
import type {
  GroupedScheduleResponse,
  GroupedCartResponse,
  BookingResponseWithQRCode
} from '@/features/booking/types/bookingTypes';

export const ticketsService = {
  /**
   * Fetch all future bookings grouped by event schedules
   * TODO: ADD PAGINATION
   */
  async getAllTicketsGroupedByEventSchedules(): Promise<GroupedScheduleResponse[]> {
    try {
      // API returns { data: GroupedScheduleResponse[] }
      // Increased timeout to 20s for grouped API calls
      const config: Partial<InternalAxiosRequestConfig> = { timeout: 20000 };
      const response = await apiClient.get<{ data: GroupedScheduleResponse[] }>(
        '/api/booking/v1/booking/all-group-by-future-event-schedules',
        config as InternalAxiosRequestConfig
      );
      return Array.isArray(response.data) ? response.data : [];
    } catch (error) {
      console.error('Error fetching tickets grouped by event schedules:', error);
      throw new Error('Failed to fetch tickets');
    }
  },

  /**
   * Fetch all bookings grouped by carts
   */
  async getAllTicketsGroupedByCarts(): Promise<GroupedCartResponse[]> {
    try {
      // API returns { data: GroupedCartResponse[] }
      // Increased timeout to 20s for grouped API calls
      const config: Partial<InternalAxiosRequestConfig> = { timeout: 20000 };
      const response = await apiClient.get<{ data: GroupedCartResponse[] }>(
        '/api/booking/v1/booking/all-group-by-carts',
        config as InternalAxiosRequestConfig
      );
      return Array.isArray(response.data) ? response.data : [];
    } catch (error) {
      console.error('Error fetching tickets grouped by carts:', error);
      throw new Error('Failed to fetch tickets');
    }
  },

  /**
   * Get a specific booking by ID with QR codes
   */
  async getTicketById(bookingId: string): Promise<BookingResponseWithQRCode> {
    try {
      // API returns { data: BookingResponseWithQRCode }
      const response = await apiClient.get<{ data: BookingResponseWithQRCode }>(`/api/booking/v1/booking/${bookingId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching ticket:', error);
      throw new Error('Failed to fetch ticket');
    }
  },

  /**
   * Fetch all past bookings grouped by event schedules
   */
  async getAllTicketsGroupedByPastEventSchedules(): Promise<GroupedScheduleResponse[]> {
    try {
      // API returns { data: GroupedScheduleResponse[] }
      // Increased timeout to 20s for grouped API calls
      const config: Partial<InternalAxiosRequestConfig> = { timeout: 20000 };
      const response = await apiClient.get<{ data: GroupedScheduleResponse[] }>(
        '/api/booking/v1/booking/all-group-by-past-event-schedules',
        config as InternalAxiosRequestConfig
      );
      return Array.isArray(response.data) ? response.data : [];
    } catch (error) {
      console.error('Error fetching past event schedules:', error);
      throw new Error('Failed to fetch past tickets');
    }
  }
};
